import React from 'react';
import PropTypes from 'prop-types';

const DispatchMapMarker = ({
  number,
  $hover,
  clickCallback,
  active,
  identifier,
  tooltip,
  lastClick,
}) => {
  const markerStyles = {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    zIndex: lastClick ? 10 : 1,
  };

  const size = $hover
    ? { width: '43px', height: '55px' }
    : { width: '38px', height: '51px' };

  const color = active ? '#05CD78' : '#D8D8D8';

  const changeStatus = () => {
    clickCallback(identifier);
  };

  return (
    <div
      style={markerStyles}
      className='dispatch-map-marker'
      id={`dipatch-map-marker-${identifier}`}
    >
      <svg
        width={size.width}
        height={size.height}
        viewBox='0 0 38 51'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        cursor='pointer'
        onClick={changeStatus}
      >
        <title>{tooltip}</title>
        <defs>
          <filter
            x='-30.8%'
            y='-25.0%'
            width='161.5%'
            height='150.0%'
            filterUnits='objectBoundingBox'
            id={`filter-1-${identifier}`}
          >
            <feOffset
              dx='1'
              dy='1'
              in='SourceAlpha'
              result='shadowOffsetOuter1'
            />
            <feGaussianBlur
              stdDeviation='1.5'
              in='shadowOffsetOuter1'
              result='shadowBlurOuter1'
            />
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.250849185 0'
              type='matrix'
              in='shadowBlurOuter1'
              result='shadowMatrixOuter1'
            />
            <feMerge>
              <feMergeNode in='shadowMatrixOuter1' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
          <polygon
            id={`path-2-${identifier}`}
            points='4.7706422e-05 0.0967248062 25.9132936 0.0967248062 25.9132936 31 4.7706422e-05 31'
          />
          <circle id={`path-4-${identifier}`} cx='13' cy='37' r='3' />
          <filter
            x='-75.0%'
            y='-75.0%'
            width='283.3%'
            height='283.3%'
            filterUnits='objectBoundingBox'
            id={`filter-5-${identifier}`}
          >
            <feMorphology
              radius='0.5'
              operator='dilate'
              in='SourceAlpha'
              result='shadowSpreadOuter1'
            />
            <feOffset
              dx='1'
              dy='1'
              in='shadowSpreadOuter1'
              result='shadowOffsetOuter1'
            />
            <feGaussianBlur
              stdDeviation='1.5'
              in='shadowOffsetOuter1'
              result='shadowBlurOuter1'
            />
            <feComposite
              in='shadowBlurOuter1'
              in2='SourceAlpha'
              operator='out'
              result='shadowBlurOuter1'
            />
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
        </defs>
        <g
          id={`Symbols-${identifier}`}
          stroke='none'
          strokeWidth='1'
          fill='none'
          fillRule='evenodd'
        >
          <g
            id={`submission-location-${identifier}`}
            transform='translate(6.000000, 6.000000)'
          >
            <g
              id={`Group-6-${identifier}`}
              filter={`url(#filter-1-${identifier})`}
            >
              <g id={`Group-3-${identifier}`}>
                <mask id={`mask-3-${identifier}`} fill='white'>
                  <use href={`#path-2-${identifier}`} />
                </mask>
                <g id={`Clip-2-${identifier}`} />
                <path
                  d='M25.9133413,13.1499597 C25.9133413,5.94077752 20.1123596,0.0966767442 12.9566349,0.0966767442 C5.80091009,0.0966767442 4.7706422e-05,5.94077752 4.7706422e-05,13.1499597 C4.7706422e-05,18.0447155 2.67470826,22.3093783 6.63159817,24.5436612 C7.84691927,25.5879287 12.9798917,31.0000721 12.9566349,31.0000721 C12.9336165,31.0000721 17.9899009,25.6413977 19.2541211,24.5592814 C23.2261578,22.329324 25.9133413,18.0561302 25.9133413,13.1499597'
                  id={`Fill-1-${identifier}`}
                  fill={color}
                  mask={`url(#mask-3-${identifier})`}
                />
              </g>
            </g>
            <g id={`Oval-${identifier}`} fillRule='nonzero'>
              <use
                fill='black'
                fillOpacity='1'
                filter={`url(#filter-5-${identifier})`}
                href={`#path-4-${identifier}`}
              />
              <use
                stroke='#FFFFFF'
                strokeWidth='1'
                fill={color}
                href={`#path-4-${identifier}`}
              />
            </g>
            <text
              id={`4-${identifier}`}
              fontFamily='Helvetica-Bold, Helvetica'
              fontSize='10'
              fontWeight='bold'
              fill='#FFFFFF'
            >
              <tspan
                x='10'
                y='17'
                className='dispatch-marker-number'
                id={`dispatch-marker-number-${identifier}`}
              >
                {number}
              </tspan>
            </text>
          </g>
        </g>
      </svg>
    </div>
  );
};

DispatchMapMarker.propTypes = {
  number: PropTypes.number.isRequired,
  $hover: PropTypes.bool,
  clickCallback: PropTypes.func,
  active: PropTypes.bool,
  identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.string,
  lastClick: PropTypes.bool,
};

DispatchMapMarker.defaultProps = {
  $hover: false,
  clickCallback: () => {},
  active: false,
  identifier: null,
  tooltip: '',
  lastClick: false,
};

export default DispatchMapMarker;
